/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';

import GitHubIcon from '@mui/icons-material/GitHub';
import TwitterIcon from '@mui/icons-material/Twitter';
import { Grid, Typography } from '@mui/material';

import { FacebookIcon } from '../../../../components/svg-icons/FacebookIcon';
import { LinkedInIcon } from '../../../../components/svg-icons/LinkedInIcon';
import { XingIcon } from '../../../../components/svg-icons/XingIcon';
import { createFooterSectionStyles } from './FooterSection.styles';

export const FooterSection = memo(() => {
  const classes = createFooterSectionStyles();

  return (
    <Grid item md={12} className={classes.root}>
      <Typography classes={{ root: classes.link }}>
        <a href="https://www.cybertec-postgresql.com/" target="_blank" rel="noopener noreferrer">
          cybertec-postgresql.com
        </a>
      </Typography>
      <div className={classes.socialContainer}>
        <a
          className={classes.socialLink}
          href="https://www.facebook.com/cybertec.postgresql/"
          target="blank"
          rel="noopener noreferrer"
        >
          <FacebookIcon />
        </a>
        <a
          className={classes.socialLink}
          href="https://twitter.com/PostgresSupport"
          target="blank"
          rel="noopener noreferrer"
        >
          <TwitterIcon />
        </a>
        <a
          className={classes.socialLink}
          href="https://www.linkedin.com/company/cybertec-sch-nig-&-sch-nig-gmbh/"
          target="blank"
          rel="noopener noreferrer"
        >
          <LinkedInIcon />
        </a>
        <a
          className={classes.socialLink}
          href="https://www.xing.com/companies/cybertecsch%C3%B6nig&sch%C3%B6niggmbh"
          target="blank"
          rel="noopener noreferrer"
        >
          <XingIcon />
        </a>
        <a
          className={classes.socialLink}
          href="https://github.com/cybertec-postgresql"
          target="blank"
          rel="noopener noreferrer"
        >
          <GitHubIcon />
        </a>
      </div>
    </Grid>
  );
});
